import React,{useState,useEffect}from "react";
import {Select,Modal,Button} from 'antd';
import {MailOutlined} from '@ant-design/icons';
import {mesesArray} from '../helpers/const'
import moment from 'moment'

const { Option } = Select;



function SelectMarcas(props) {

    const marcas = props.marcas?props.marcas:[]
    const [unidades, setUnidades] = useState([]);
   
    const [valueUnidad, setValueUnidad] = useState(0);
    const [valueMarca, setValueMarca] = useState(0);

    const [nameUnidad, setNameUnidad] = useState(0);
    const [nameMarca, setNameMarca] = useState(0);

    const [valueMes, setValueMes] = useState(0);
    const [nameMes, setNameMes] = useState(0);

    useEffect(() => {

        if (marcas.length>0)
        {
            let itemMarca = marcas[0]
            let itemUnidad = itemMarca.marcaUnidades.length>0?itemMarca.marcaUnidades[0].unidad:{}

            setNameMarca(itemMarca.nombre)
            setNameUnidad(itemUnidad.nombre)
            setValueMarca(itemMarca.id)
            setValueUnidad(itemUnidad.id)
            setUnidades(marcas[0].marcaUnidades)
            setNameMes(mesesArray[moment().format('M')])
            setValueMes(Number(moment().format('M')))
        }

    },[marcas]);



    function onChangeMarca(value,option)
    {  

        setValueMarca(value)
        setNameMarca(option.name)

        setUnidades(marcas[option.key].marcaUnidades)

        let itemMarca = marcas[option.key]
        let itemUnidad = itemMarca.marcaUnidades.length>0?itemMarca.marcaUnidades[0].unidad:{}
        setValueMarca(itemMarca.id)
        setValueUnidad(itemUnidad.id)
        
    }

    function onCancel()
    {  
        props.onCancel()
    }

    function onChangeFilter()
    {
        props.onChangeFilter(valueMarca,valueUnidad,nameMarca,nameUnidad,valueMes)
    }

    function onChangeUnidad(value,option)
    {
        setNameUnidad(option.name)
        setValueUnidad(value)
    }


    function onChangeMes(value,option)
    {
        setNameMes(option.name)
        setValueMes(value)
    }

    return (

        <Modal
               width={300}
               title="Seleccione tipo de filtro"
               footer ={null}
               open={props.visible}
               onOk={null}
               onCancel={onCancel}>
        <div>
        Marca:
        <Select  value={valueMarca}  style={{width: 260,marginBottom:"24px"}} onChange={onChangeMarca}>
            {   
                marcas.map((marca,index)=>
                {
                    return  <Option key={index} value={marca.id} name={marca.nombre}>{marca.nombre}</Option>
                })
            }   
         </Select>
         Unidad:
         <Select value={valueUnidad}  style={{ width: 260,marginBottom:"24px"}} onChange={onChangeUnidad}>
            {   
                unidades.map((unidad,index)=>
                {

                    return  <Option key={index} value={unidad.unidad.id} name={unidad.unidad.nombre}>{unidad.unidad.nombre}</Option>
                })
            }   
         </Select>
         {
            props.meses?<div>
                         Mes:
                          <Select value={valueMes}  style={{ width: 260 }} onChange={onChangeMes}>
                            {   
                                mesesArray.map((item,index)=>
                                {
                                    return  index!=0?<Option key={index} value={index} name={item}>{item}</Option>:null
                                })
                            }   
                         </Select>
                         </div>:null
         }
         <div style={{textAlign:"end",width: 260,marginTop:"24px"}}>
          <Button  style={{width: 100}} type="primary" onClick={onChangeFilter}>
            OK
          </Button>
        </div>   
        </div>
         </Modal>
    );
}

export default SelectMarcas;